import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

const useStyles = makeStyles(theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing(2.5)
    }
}));

export default function PaginationActions(props) {
    const { count, page, rowsPerPage, onPageChange } = props;
    const classes = useStyles();
    const theme = useTheme();

    function onFirstPageButtonClick(event) {
        onPageChange(event, 0);
    }

    function onBackButtonClick(event) {
        onPageChange(event, page - 1);
    }

    function onNextButtonClick(event) {
        onPageChange(event, page + 1);
    }

    function onLastPageButtonClick(event) {
        onPageChange(
            event,
            Math.max(0, Math.ceil(count / rowsPerPage) - 1)
        );
    }

    return (
        <div className={classes.root}>
            <IconButton
                onClick={onFirstPageButtonClick}
                disabled={page === 0}
                aria-label='Primeira Página'>
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={onBackButtonClick}
                disabled={page === 0}
                aria-label='Página Anterior'>
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={onNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label='Próxima Página'>
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={onLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label='Última Página'>
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

PaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired
};